import CmsContentPage from "./CmsContentPage";

const FALLBACK =
  "https://images.unsplash.com/photo-1699325635304-a2f409b06d19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxwb3JzY2hlJTIwOTExJTIwZ3JleXxlbnwwfHx8fDE3NzgwNTM2MDJ8MA&ixlib=rb-4.1.0&q=85";

const ServicesPage = () => (
  <CmsContentPage
    pageKey="services"
    fallbackHero={FALLBACK}
    dataTestId="services-page"
  />
);

export default ServicesPage;
